import React, { useState } from "react";
import { toast } from "react-toastify";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { deleteEliminarComisionPrevision } from "../../API/ApiComisiones";
import { AuthContext } from "../../auth/authContext";
import { VendedoresContratoContext } from "../../contexts/VendedoresContratoContext";
import { checkPermisosPorUsuarioPorGuidPantalla } from "../../API/ApiPermisos";

const guidVista = "6ac593c2-4810-4081-bb29-e80830750a85"; // GUID de la vista para permisos
const guidFuncion = "a6a35acc-afb7-42c2-a943-865fe0e88775";

const EliminarComisionesComponent = (props) => {
  const { user, dispatch } = React.useContext(AuthContext);

  const { dataVendedoresContext, setDataVendedoresContext } = React.useContext(
    VendedoresContratoContext
  );

  const [showModal, setShowModal] = useState(false);
  const [confirmText, setConfirmText] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const [checkPersmissions, setCheckPermissions] = React.useState([]);

  const [permisoParaVisualizar, setPermisoParaVisualizar] =
    React.useState(false);

  const handleConfirmDelete = () => {
    setIsDeleting(true);

    deleteEliminarComisionPrevision(user, props.data.contrato).then(
      (response) => {
        if (response.status === 200) {
          setIsDeleting(false);
          setIsSuccess(true);
          toast.success("Comisiones eliminadas exitosamente.");
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          setIsDeleting(false);
          toast.error("Error al eliminar las comisiones.");
        }
      }
    );
  };

  const isFormValid =
    confirmText.trim().toUpperCase() === "CONFIRMAR" && isChecked;

  console.log(props);

  React.useEffect(() => {
    checkPermisosPorUsuarioPorGuidPantalla(user, guidVista).then(
      (resultado) => {
        if (resultado.status == 200) {
          setCheckPermissions(resultado.data);

          for (const permiso of resultado.data) {
            if (
              permiso.guidFuncion == guidFuncion &&
              permiso.allowed == 1
            ) {
              setPermisoParaVisualizar(true);
            }
          }
        }
      }
    );
  }, []);

  return (
    <>
      {permisoParaVisualizar && (
        <button
          onClick={() => setShowModal(true)}
          className="btn btn-danger w-100 mt-2"
        >
          Eliminar Comisiones ❌
        </button>
      )}

      {/* Modal */}
      <div
        className={`modal fade ${showModal ? "show d-block" : ""}`}
        tabIndex="-1"
        style={{
          backgroundColor: showModal ? "rgba(0,0,0,0.5)" : "transparent",
        }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                Confirmar Eliminación de Comisiones
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowModal(false)}
                disabled={isDeleting}
              ></button>
            </div>
            <div className="modal-body text-center">
              {isSuccess ? (
                <div className="text-success">
                  <h4>✅ ¡Éxito!</h4>
                  <p>Las comisiones han sido eliminadas correctamente.</p>
                  <p className="text-muted">Recargando página...</p>
                </div>
              ) : (
                <>
                  <p>
                    <strong>⚠️ Advertencia:</strong> Se procederá a eliminar el
                    proceso de comisiones, incluyendo, vendedor, comisiones y
                    pagos efectuados al día de hoy, ¿Deseas continuar?
                  </p>

                  <div className="mb-3">
                    <label htmlFor="confirmText" className="form-label">
                      Escriba "CONFIRMAR" para continuar:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="confirmText"
                      value={confirmText}
                      onChange={(e) => setConfirmText(e.target.value)}
                      placeholder="Escriba CONFIRMAR"
                      disabled={isDeleting}
                    />
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="confirmCheckbox"
                      checked={isChecked}
                      onChange={(e) => setIsChecked(e.target.checked)}
                      disabled={isDeleting}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="confirmCheckbox"
                    >
                      Entiendo que esta acción no se puede deshacer
                    </label>
                  </div>
                </>
              )}
            </div>
            <div className="modal-footer">
              {!isSuccess && (
                <>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                    disabled={isDeleting}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={!isFormValid || isDeleting}
                    onClick={handleConfirmDelete}
                  >
                    {isDeleting ? (
                      <>
                        <AiOutlineLoading3Quarters className="spinner-border spinner-border-sm me-2" />
                        Eliminando... no cierres la ventana
                      </>
                    ) : (
                      "Eliminar Comisiones"
                    )}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EliminarComisionesComponent;
